import React, { useState, useEffect } from "react";

import _ from "lodash";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";

import DownloadButton from "./downloadButton";
import LegislativeView from "./legislativeView";
import { fetchLegislators } from "../utilities/apiWrapper";
import {
  genderOptions,
  raceOptions,
  regionOptions,
  fieldNames,
  races,
  parties,
} from "../utilities/constants";
import utils from "../utilities/utils";
const { LEGISLATIVE_CONFERENCE } = fieldNames;

function LegislativeContainer(props) {
  const [genderFilter, setGenderFilter] = useState("");
  const [raceFilter, setRaceFilter] = useState("");
  const [regionFilter, setRegionFilter] = useState("");
  const [committeeFilter, setCommitteeFilter] = useState([]);

  let people = props.people;
  let fetchLegislatorsAction = props.fetchLegislatorsAction;
  let governmentBody = props.governmentBody;
  let addLegislatorAction = props.addLegislatorAction;

  useEffect(() => {
    if (people.length === 0) {
      fetchLegislatorsAction({
        governmentBody,
        addLegislatorAction,
      });
    }
  }, [
    governmentBody,
    people.length,
    addLegislatorAction,
    fetchLegislatorsAction,
  ]);

  function collectLegislativeGroups() {
    const {
      democraticConference,
      republicanConference,
      independentConference,
      conservativeConference,
      undecidedConference,
      unknownConference,
    } = props;

    const groups = {
      Democratic: democraticConference,
      Republican: republicanConference,
      Independent: independentConference,
      Conservative: conservativeConference,
      Undecided: undecidedConference,
      Unknown: unknownConference,
    };

    // Filter out groups where the length is 0
    return Object.fromEntries(
      Object.entries(groups).filter(([key, value]) => value.length > 0),
    );
  }

  function collectLegislativeGroupCounts() {
    let demCount = getGroupCount("democraticConference");
    let repCount = getGroupCount("republicanConference");
    let independentCount = getGroupCount("independentConference");
    let conservativeCount = getGroupCount("conservativeConference");
    let undecidedCount = getGroupCount("undecidedConference");
    let unknownCount = getGroupCount("unknownConference");

    const counts = {
      Democratic: demCount,
      Republican: repCount,
      Independent: independentCount,
      Conservative: conservativeCount,
      Undecided: undecidedCount,
      Unknown: unknownCount,
    };

    return counts;
  }

  function getGroupCount(group) {
    if (!genderFilter && !raceFilter && !regionFilter && !committeeFilter) {
      return props[group].length;
    } else {
      return utils.updateCounts({
        peopleByGroup: props[group],
        genderFilter: genderFilter,
        raceFilter: raceFilter,
        regionFilter: regionFilter,
        committeeFilter: committeeFilter,
      });
    }
  }

  return (
    <div className="houses">
      <DownloadButton governmentBody={props.governmentBodyShort} />
      <div className="house-components">
        <div className="select-container">
          <Select
            className="select-item"
            isMulti
            placeholder="Filter by Gender..."
            options={genderOptions}
            onChange={(event) =>
              setGenderFilter(event.map((choice) => choice.value))
            }
          />
          <Select
            className="select-item"
            isMulti
            placeholder="Filter by Race..."
            options={raceOptions}
            onChange={(event) =>
              setRaceFilter(event.map((choice) => choice.value))
            }
          />
          {props.showRegionFilter && (
            <Select
              className="select-item"
              isMulti
              placeholder="Filter by Region..."
              options={regionOptions}
              onChange={(event) =>
                setRegionFilter(event.map((choice) => choice.value))
              }
            />
          )}

          {props.showCommitteeFilter && (
            <Select
              className="select-item"
              isMulti
              placeholder="Filter by Committee..."
              options={utils.setCommitteeOptions(props.people)}
              onChange={(event) =>
                setCommitteeFilter(event.map((choice) => choice.value))
              }
            />
          )}
        </div>

        <LegislativeView
          governmentBody={props.governmentBody}
          groups={collectLegislativeGroups()}
          groupCount={collectLegislativeGroupCounts()}
          sm={props.colSize.sm}
          md={props.colSize.md}
          lg={props.colSize.lg}
          genderFilter={genderFilter}
          raceFilter={raceFilter}
          regionFilter={regionFilter}
          committeeFilter={committeeFilter}
        />
        <Row>
          <div className="legend">
            <h4>Legend</h4>
            {utils.renderLegend(
              races,
              parties,
              props.people,
              "Conference Legislators",
            )}
          </div>
        </Row>
      </div>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  const fetchedPeople = _.get(state, [ownProps.governmentBodyShort], []);

  const people = fetchedPeople.map((person) => {
    if (!person.fields[LEGISLATIVE_CONFERENCE]) {
      person.fields[LEGISLATIVE_CONFERENCE] = ["Unknown"];
    }
    return person;
  });

  const democraticConference = people.filter((person) =>
    person.fields[LEGISLATIVE_CONFERENCE].includes("Democratic"),
  );
  const republicanConference = people.filter(
    (person) =>
      person.fields[LEGISLATIVE_CONFERENCE].includes("Republican") ||
      (ownProps.governmentBodyShort === "senate" &&
        person.fields[LEGISLATIVE_CONFERENCE].includes(
          "Independent Democratic Conference",
        )),
  );
  const independentConference = people.filter((person) =>
    person.fields[LEGISLATIVE_CONFERENCE].includes("Independent"),
  );
  const conservativeConference = people.filter((person) =>
    person.fields[LEGISLATIVE_CONFERENCE].includes("Conservative"),
  );
  const unknownConference = people.filter((person) =>
    person.fields[LEGISLATIVE_CONFERENCE].includes("Unknown"),
  );

  const undecidedConference = people.filter((person) =>
    person.fields[LEGISLATIVE_CONFERENCE].includes("Undecided"),
  );

  return {
    governmentBodyShort: ownProps.governmentBodyShort,

    people: people,
    democraticConference: utils.sortByRaceAndName(democraticConference),
    republicanConference: utils.sortByRaceAndName(republicanConference),
    independentConference: utils.sortByRaceAndName(independentConference),
    conservativeConference: utils.sortByRaceAndName(conservativeConference),
    undecidedConference: undecidedConference,
    unknownConference: unknownConference,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchLegislatorsAction: bindActionCreators(fetchLegislators, dispatch),
  };
}

const componentCreator = connect(mapStateToProps, mapDispatchToProps);
export default componentCreator(LegislativeContainer);
